export const SKELETON_DATA = [
  { x: 1, y: 350 },
  { x: 3, y: 300 },
  { x: 12, y: 240 },
  { x: 15, y: 250 },
  { x: 18, y: 230 },
];
